import React from 'react';

const submissionTypeConfig: Record<string, { label: string; color: string }> = {
  quick_enquiry: {
    label: 'Quick Enquiry',
    color: 'text-brand-neonBlue border-brand-neonBlue/30 bg-brand-neonBlue/10',
  },
  event_builder: {
    label: 'Event Builder',
    color: 'text-violet-300 border-violet-400/30 bg-violet-400/10',
  },
  brainstorm: {
    label: 'Brainstorm',
    color: 'text-brand-neonPink border-brand-neonPink/30 bg-brand-neonPink/10',
  },
};

export const SubmissionTypeBadge: React.FC<{ submissionType?: string | null; compact?: boolean }> = ({
  submissionType,
  compact = false,
}) => {
  if (!submissionType) return null;

  const config = submissionTypeConfig[submissionType] || {
    label: submissionType.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase()),
    color: 'text-slate-300 border-white/10 bg-white/5',
  };

  return (
    <span className={`${compact ? 'text-[8px] px-2 py-1 rounded-md' : 'text-[9px] px-3 py-1 rounded-full'} inline-flex items-center font-black uppercase tracking-widest border whitespace-nowrap ${config.color}`}>
      {config.label}
    </span>
  );
};
